import { render, staticRenderFns } from "./TokenAppImpressao.vue?vue&type=template&id=43b2c462&scoped=true"
import script from "./TokenAppImpressao.vue?vue&type=script&lang=js"
export * from "./TokenAppImpressao.vue?vue&type=script&lang=js"
import style0 from "./TokenAppImpressao.vue?vue&type=style&index=0&id=43b2c462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b2c462",
  null
  
)

export default component.exports